import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useStoryDetails from '../../hooks/useStoryDetails';
import ContentState from '../Brand/ContentState';
import { UsersIcon } from '../Brand/Icon';
import './index.scss';

export function StatisticParticipants({ scope, link }) {
  const { t, i18n } = useTranslation('brand');
  // cnt is returned by the same API aggregation that produces the bars.
  // Never infer a headcount from rounded percentages or visible public authors.
  if (!scope.every(({ cnt }) => Number.isSafeInteger(cnt) && cnt >= 0)) return null;
  const count = scope.reduce((sum, { cnt }) => sum + cnt, 0);
  const formatted = new Intl.NumberFormat(i18n.language || 'en').format(count);
  const Container = link ? Link : 'div';
  return <Container {...link} className="statistic-participants" aria-label={t('participantsTotal', { total: formatted })}>
    <UsersIcon aria-hidden="true" /><span>{formatted}</span>
  </Container>;
}

export function StatisticChart({ scope = [], className = '' }) {
  const { t } = useTranslation();
  const percentages = scope.map(({ proc }) => Math.max(0, Number(proc) || 0));
  const maximum = Math.max(0, ...percentages);

  // The highest bar uses 3/4 of the plot. Labels keep the actual vote percentages.
  return (
    <div className={`statistic_chart opinion-statistic-chart ${className}`} tabIndex={0} role="region" aria-label={t('story.statistics')}>
      {scope.map((item, index) => {
        const height = maximum > 0 ? percentages[index] / maximum * 75 : 0;
        const empty = percentages[index] === 0;
        return (
          <div className={`bar_block${empty ? ' bar_block--empty' : ''}`} key={`bar${item.scope}`}
            style={{ '--bar-height': empty ? 'var(--stat-baseline-height)' : `${height}%` }}>
            <div className="bar_text"><span className="bar_label">{item.proc}%</span></div>
            <div className={`bar${item.scope} bar`} aria-hidden="true" />
          </div>
        );
      })}
    </div>
  );
}

export default function PostStatistic(props) {
  const { storyId } = props;
  const { list: scope, status, retry } = useStoryDetails(storyId, 'statistics', { loadTitle: false });
  if (status !== 'ready') return <ContentState status={status} onRetry={retry} />;
  return <div className="post-statistic">
    <StatisticParticipants scope={scope} />
    {scope.some(({ proc, cnt }) => proc > 0 || cnt > 0)
      ? <StatisticChart scope={scope} />
      : <ContentState status="empty" emptyKey="statisticsEmpty" />}
  </div>;
}
